import { loginSendCode, loginRegisterCode, payReviseSendCode, changePasswordSendCode } from "@/api/login";

let timer = null;

const state = {
  code_phone: null, // 已发送验证码的手机号
  code_flag: false, // 是否在倒计时
  code_timeout: 60, // 已发送短信验证码倒计时
};

const mutations = {
  SET_CODE_PHONE(state, data) {
    state.code_phone = data;
  },
  SET_CODE_FLAG(state, data) {
    state.code_flag = data;
  },
  RESET_CODE(state) {
    state.code_phone = null;
    state.code_flag = false;
  },
  RESET_CODE_TIMEOUT(state) {
    state.code_timeout = 60;
    clearInterval(timer);
  },
  SET_CODE_TIMEOUT(state) {
    if (state.code_timeout !== 0) {
      state.code_timeout--;
    } else {
      state.code_flag = false;
      state.code_timeout = 60;
      clearInterval(timer);
    }
  },
};

const actions = {
  // 登录获取验证码
  loginSendCode({ commit }, phone) {
    return new Promise((resolve, reject) => {
      if (timer) {
        commit("RESET_CODE_TIMEOUT");
      }
      loginSendCode({
        mobile: phone,
      })
        .then((res) => {
          commit("SET_CODE_FLAG", true);
          commit("SET_CODE_PHONE", phone);
          commit("SET_CODE_TIMEOUT");
          timer = setInterval(() => {
            commit("SET_CODE_TIMEOUT");
          }, 1000);
          resolve(true);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 发送注册验证码
  loginRegisterCode({ commit }, phone) {
    return new Promise((resolve, reject) => {
      if (timer) {
        commit("RESET_CODE_TIMEOUT");
      }
      loginRegisterCode({
        mobile: phone,
      })
        .then((res) => {
          commit("SET_CODE_FLAG", true);
          commit("SET_CODE_PHONE", phone);
          commit("SET_CODE_TIMEOUT");
          timer = setInterval(() => {
            commit("SET_CODE_TIMEOUT");
          }, 1000);
          resolve(true);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 修改登录密码获取验证码
  changePasswordSendCode({ commit }, phone) {
    return new Promise((resolve, reject) => {
      if (timer) {
        commit("RESET_CODE_TIMEOUT");
      }
      changePasswordSendCode({
        mobile: phone,
      })
        .then((res) => {
          commit("SET_CODE_FLAG", true);
          commit("SET_CODE_PHONE", phone);
          commit("SET_CODE_TIMEOUT");
          timer = setInterval(() => {
            commit("SET_CODE_TIMEOUT");
          }, 1000);
          resolve(true);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 修改付款码获取验证码
  payReviseSendCode({ commit }, phone) {
    return new Promise((resolve, reject) => {
      if (timer) {
        commit("RESET_CODE_TIMEOUT");
      }
      payReviseSendCode({
        mobile: phone,
      })
        .then((res) => {
          commit("SET_CODE_FLAG", true);
          commit("SET_CODE_PHONE", phone);
          commit("SET_CODE_TIMEOUT");
          timer = setInterval(() => {
            commit("SET_CODE_TIMEOUT");
          }, 1000);
          resolve(true);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  resetCode({ commit }) {
    commit("RESET_CODE_TIMEOUT");
    commit("RESET_CODE");
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
